import { render, staticRenderFns } from "./UserRechargeList.vue?vue&type=template&id=025174f2&scoped=true"
import script from "./UserRechargeList.vue?vue&type=script&lang=js"
export * from "./UserRechargeList.vue?vue&type=script&lang=js"
import style0 from "./UserRechargeList.vue?vue&type=style&index=0&id=025174f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025174f2",
  null
  
)

export default component.exports